<app-header bgColor="rgb(90 99 255 / 59%)"></app-header>
<section class="airdrop" id="airdrop">
    <div class="airdrop-title-wrapper">
        <div class="container">
            <div class="col-md-12">
                <h3 class="text-center airdrop-title" translate>airdrop_title</h3>
                <p class="text-center airdrop-para mb-3" translate>airdrop_para1</p>
                <!-- <p class="text-center airdrop-para my-4 wd-sm-45 wd-100 " translate>airdrop_para2</p> -->
            </div>
        </div>
    </div>
    <div class="container airdrop-content max-container ">
        <div class="row mb-4">
            <div class="col-lg-6 offset-lg-3">
                <h2 class="text-black main-title fw-semibold text-secondary mb-4 mt-lg-0 text-center m-0" translate>
                    airdrop-started</h2>
                <div class="list-wrapper">
                    <div class="list-item mb-0">
                        <span class="counter" translate>airdrop-item1</span>
                        <p translate>airdrop-list-item1</p>
                    </div>
                    <div class="app-img d-flex flex-wrap flex-sm-nowrap align-items-center">
                        <a href="" class="wd-100 wd-sm-28 me-2 mb-3">
                            <img src="/assets/images/app-Store.svg" alt="" class="img-fluid">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.bestwallet.mobile&pli=1"
                            class="wd-100 wd-sm-28 me-2 mb-3" target="_blank">
                            <img src="./assets/images/google-pay.svg" alt="" class="img-fluid">
                        </a>
                    </div>
                    <div class="list-item">
                        <span class="counter" translate>airdrop-item2</span>
                        <p translate>airdrop-list-item2</p>
                    </div>
                    <div class="list-item">
                        <span class="counter" translate>airdrop-item3</span>
                        <p translate>airdrop-list-item3</p>
                    </div>
                </div>
                <div class="app-listing">

                    <iframe id="myiFrame" width="100%" height="715px" name=”iframe”
                        src="https://dashboard.withblaze.app/forms/7c92e3dea64ecb343752344d4e5aef7f/"
                        title="description"></iframe>
                    <!-- <ul>
                        <li *ngFor="let item of items">
                            <span class="icon-wrapper"></span>
                            <p class="app-listing-name" translate>{{item.name}}</p>
                            <span class="badge-green" translate>{{item.badge}}</span>
                        </li>
                    </ul> -->
                </div>
            </div>
            <div class="col-lg-6 offset-lg-3">
                <h2 class="main-title text-black fw-semibold text-secondary mb-5 mt-lg-0 text-center  m-0" translate>
                    airdrop-earn-point</h2>
            </div>
            <div class="col-lg-4 img-div" *ngFor="let card of cards">
                <img class="mb-4 earn-points-img" src="{{card.img}}" alt="card-img">
                <h4 class="text-center mb-3 px-3 fw-semibold font-20" translate>{{card.title}}</h4>
                <!-- <p class="text-center text-light px-3 font-15" translate>{{card.desc}}</p> -->
            </div>
            <!-- <div class="mt-5 robo">
                <img class="img-fluid" src="./assets/images/parachute.svg" alt="">
            </div> -->

        </div>
    </div>

    <div class="container">
        <div class="faq row mb-2 justify-content-center">
            <div class=" faq-wraper">
                <div class="questions-div">
                    <h2 class="para1">{{"faq-para1" | translate}}</h2>
                    <h2 class="para2">{{"faq-para2" | translate}}</h2>
                    <p class="para3">{{"faq-para3" | translate}}</p>
                    <p class="para3">{{"faq-para4" | translate}}</p>
                </div>
                <div class='accord-div'>
                    <div *ngFor="let item of data; let i = index;">
                        <div class="accordion-wrapper">
                        </div>
                        <button class="accordion click" (click)="toggleAccordian($event, i)">
                            {{item.parentName | translate}}
                        </button>
                        <div class="panel" hide="!item.isActive">
                            <p *ngFor="let child of item.childProperties" class="fw-regular font-16 px-4 ">
                                <span [innerHTML]="(child.propertyName | translate) | dynamicLink: child.links"></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>